import * as s from "./AuthTransitionScreen.style.css";

export interface AuthTransitionScreenProps {
  /** Short status line under the lion mark. */
  message?: string;
  /**
   * "full" (default) — whole-viewport transitions with no persistent chrome
   * yet (e.g. auth/redirect handoffs).
   * "fill" — fills a content area that sits below a persistent app shell/nav.
   * "compact" — small embedded widgets/tiles.
   */
  variant?: "full" | "fill" | "compact";
  /** Invert the mark regardless of app theme — for hosts with a hardcoded dark background (e.g. MicroGrid tiles). */
  invert?: boolean;
}

/**
 * The canonical transitional/loading status component for this app. Always
 * use this (with the appropriate `variant`) for auth/session transitions and
 * async loading states — do not hand-roll plain "Loading…" / "Checking
 * access…" text in a <Text> or <div>.
 *
 * Full-bleed or container-filling branded handoff screen, depending on
 * `variant`. Soft fade/scale entrance + gentle opacity pulse on the lion mark.
 */
export function AuthTransitionScreen({
  message = "Redirecting…",
  variant = "full",
  invert = false,
}: AuthTransitionScreenProps) {
  return (
    <div
      className={s.root({ variant })}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={s.stack}>
        <img
          src="/logos/lion_energy_lion.svg"
          alt=""
          width={variant === "compact" ? 20 : variant === "fill" ? 32 : 44}
          height={variant === "compact" ? 20 : variant === "fill" ? 32 : 44}
          className={s.mark({ variant, invert })}
        />
        <p className={s.message({ variant })}>{message}</p>
      </div>
    </div>
  );
}
